import { useLayoutEffect, useState } from 'react';

const useMediaQuery = (query = '(max-width: 768px)') => {
  const [matches, setMatches] = useState(
    () => window.matchMedia(query).matches
  );

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = (e) => setMatches(e.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
